import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { useDeletePartyGroupMutation } from 'store/api/groups';
import { t } from 'utils/getTranslations';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState';

/**
 * Deleting a group: asks first, then leaves for where the user came from. `beforeLeave` runs once the group is
 * gone, such as a form letting its navigation guard go.
 */
export const useDeleteGroup = (groupId: string | undefined, beforeLeave?: () => void) => {
    const { openModal, closeModal } = useModal();
    const [deleteGroup] = useDeletePartyGroupMutation();
    const leaveDeleted = useLeaveDeletedEntity('/groups');

    return () => {
        if (!groupId || isNaN(Number(groupId))) {
            return;
        }
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    void deleteGroup({ id: groupId })
                        .unwrap()
                        .then(() => {
                            beforeLeave?.();
                            leaveDeleted();
                        })
                        .catch(console.error)
                        .finally(() => closeModal());
                }}
                content={<p className="text-body1">{t('groups.delete-confirmation-text')}</p>}
            />
        );
    };
};
